function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M18.231 21.486a.572.572 0 0 0 .551-.486c.789-4.361 1.22-5.15 5.715-5.745a.568.568 0 0 0 0-1.131c-4.465-.6-5.046-1.429-5.715-5.715a.561.561 0 0 0-.551-.506.577.577 0 0 0-.581.491c-.774 4.361-1.22 5.12-5.7 5.73a.566.566 0 0 0-.521.566.577.577 0 0 0 .521.566c4.465.506 5.046 1.369 5.7 5.73a.579.579 0 0 0 .581.5zM12.322 23.9a.415.415 0 0 0 .417-.357c.387-2.143.268-2.233 2.6-2.6a.405.405 0 0 0 .357-.417.417.417 0 0 0-.357-.417c-2.337-.372-2.218-.461-2.6-2.575a.431.431 0 0 0-.417-.387.444.444 0 0 0-.432.387c-.4 2.1-.253 2.173-2.6 2.575a.4.4 0 0 0-.357.417.394.394 0 0 0 .4.417c2.307.357 2.158.447 2.56 2.575a.433.433 0 0 0 .429.382z",
  transform: "translate(-4.973 -3.898)",
  fill: "currentColor"
}));

function SvgStarsGroupFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsGroupFill);
export default __webpack_public_path__ + "static/media/stars_group_fill.5e0995ce.svg";
export { ForwardRef as ReactComponent };